const linkTextStyle = {
  textDecoration: "underline",
  color: "#5271FF",
};

const currentYear = new Date().getFullYear();

const Footer = () => {
  return (
    <>
      <footer
        style={{
          paddingTop: "20px",
          textAlign: "center",
        }}
      >
        <p>
          &copy; {currentYear} キントレマニア ver{process.env.REACT_APP_VERSION}
        </p>
        <p>
          Developed and Managed by:{" "}
          <a href="https://denno-times.com" style={linkTextStyle}>
            電脳TIMES
          </a>
        </p>
      </footer>
    </>
  );
};

export default Footer;
